import { render, staticRenderFns } from "./Reservcert.vue?vue&type=template&id=b8a87aca&scoped=true&"
import script from "./Reservcert.vue?vue&type=script&lang=js&"
export * from "./Reservcert.vue?vue&type=script&lang=js&"
import style0 from "./Reservcert.vue?vue&type=style&index=0&id=b8a87aca&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8a87aca",
  null
  
)

export default component.exports